import * as React from 'react'

export default function LazyAndPreloadImage(props) {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    // preload しておく
    const img = new Image();
    img.src = props.imgUrl;

    // 読み込めたら img タグ描画する
    img.onload = () => {
      setLoaded(true)
    };
  }, [])

  if (loaded) {
    return <img className={props.className ?? ""} src={props.imgUrl} alt={props.alt} width={props.width ?? ""} height={props.height ?? ""} />;
  }

  return <img className={props.className ?? ""} width={props.width ?? ""} height={props.height ?? ""} />;
}